import * as THREE from 'three'

export default class Hotspots {
    constructor() {
        this.zonas = [
            //Zonas sociales   
            // {
            //     position: new THREE.Vector3(-0.7, 0.84, -2.4),
            //     element: document.querySelector('.hotspot-0'),
            //     label: 'Terraza',
            //     img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/terraza.jpg'
            // },
           //No se está usando en este proyecto

        ]
        this.cercanias = [
            //Cercanias        
            {
                position: new THREE.Vector3(15.67, 0.34, 32.01),
                element: document.querySelector('.hotspot-0')//Multiplaza
            },
            {
                position: new THREE.Vector3(25.5, 0.34, 501),
                element: document.querySelector('.hotspot-1')//El Eden
            },
            {
                position: new THREE.Vector3(-45.46, 0.34, 4.2),
                element: document.querySelector('.hotspot-2')//Hayuelos
            },
            {
                position: new THREE.Vector3(5.7, 0.34, -25),
                element: document.querySelector('.hotspot-3')//Tres Elefantes
            },
            {
                position: new THREE.Vector3(75, 0.34, -75),
                element: document.querySelector('.hotspot-4')//Gran Estacion
            },
            {
                position: new THREE.Vector3(-50, 0.34, 100),
                element: document.querySelector('.hotspot-5')//Uniagustiniana
            },
            {
                position: new THREE.Vector3(100, 0.34, -27),
                element: document.querySelector('.hotspot-6')//Clinica Colombia
            },
            {
                position: new THREE.Vector3(-75, 0.34, -100),
                element: document.querySelector('.hotspot-7')//Aeropuerto
            },
            {
                position: new THREE.Vector3(47.46, 0.34, -19.97),
                element: document.querySelector('.hotspot-8')//Terminal
            },
            

            //Vias
            {
                position: new THREE.Vector3(-4.2, 0.2, -2.4),
                element: document.querySelector('.hotspot-9')//Av. Ferrocarril
            },
            {
                position: new THREE.Vector3(18.7, 0.2, 6.31),
                element: document.querySelector('.hotspot-10')//Av. Boyaca
            },
            {
                position: new THREE.Vector3(4.2, 0.2, 44),
                element: document.querySelector('.hotspot-11')//Calle 13
            },
            
        ]
    }
}



